import * as List from "./List/index.js";
import * as Summary from "./Summary/index.js";
import { ListingAdPackage } from "../../../../CoStar/Api/AptsListings/ResidentialForRent/index.js";
/** CoStar.Api.AptsSearch.Result.ListingAdPackage */
export { ListingAdPackage };
/** CoStar.Api.AptsSearch.Result.ResidentialAvailabilityMatchType */
export var ResidentialAvailabilityMatchType;
(function (ResidentialAvailabilityMatchType) {
    ResidentialAvailabilityMatchType[ResidentialAvailabilityMatchType["NoMatch"] = 0] = "NoMatch";
    ResidentialAvailabilityMatchType[ResidentialAvailabilityMatchType["Perfect"] = 1] = "Perfect";
    ResidentialAvailabilityMatchType[ResidentialAvailabilityMatchType["Other"] = 2] = "Other";
    ResidentialAvailabilityMatchType[ResidentialAvailabilityMatchType["BudgetStretch"] = 3] = "BudgetStretch";
})(ResidentialAvailabilityMatchType || (ResidentialAvailabilityMatchType = {}));
import { ProsumerLevel } from "../../../../CoStar/Api/AptsListings/ViewModels/index.js";
/** CoStar.Api.AptsSearch.Result.ProsumerLevel */
export { ProsumerLevel };
export { List, Summary };
